<template>
  <div class="dettaglio-dipendente">
    <div class="header-tab row row-custom">
      <div class="return col-12">
        <icon
          name="riv-arrow2"
          scale="1.2"
          flip="horizontal"
          @click.native="link('DIPDipendenti')"
          class="pointer"
        ></icon>
        <span class="my-label">{{ $t('dettaglioDipendente.datiAnag') }}</span>
      </div>
      <div class="fornitore col-12">{{fornitore}} - {{desFornitore}}</div>
    </div>

    <div class="testata row row-custom" v-loading="loading_dip">
      <div class="col-lg-11 col-sm-20 col-22">
        <div class="row row-custom elemento">
          <div class="testata-label col-8">{{ $t('dettaglioDipendente.dipendente') }}</div>
          <div class="testata-value col-16 no-padding">
            <el-input v-model="dipendente.codDip" disabled class="custom-input"></el-input>
          </div>
        </div>
        <div class="row row-custom elemento">
          <div class="testata-label col-8">{{ $t('dettaglioDipendente.cognome') }}</div>
          <div class="testata-value col-16 no-padding">
            <el-input
              v-model="dipendente.cognome"
              :disabled="disabled"
              :maxlength="30"
              class="custom-input"
            ></el-input>
          </div>
        </div>
        <div class="row row-custom elemento">
          <div class="testata-label col-8">{{ $t('dettaglioDipendente.nome') }}</div>
          <div class="testata-value col-16 no-padding">
            <el-input
              v-model="dipendente.nome"
              :disabled="disabled"
              :maxlength="30"
              class="custom-input"
            ></el-input>
          </div>
        </div>
        <div class="row row-custom elemento" v-show="country !== '2'">
          <div class="testata-label col-8">{{ $t('dettaglioDipendente.cFisc') }}</div>
          <div class="testata-value col-16 no-padding">
            <el-input v-model="dipendente.codFisc" :disabled="disabled" class="custom-input">
              <el-button
                :disabled="disabled"
                slot="append"
                @click="validaCFisc(dipendente.codFisc)"
              >{{ $t('dettaglioDipendente.btn.convalida') }}</el-button>
            </el-input>
          </div>
        </div>
        <div class="row row-custom elemento">
          <div class="testata-label col-8">{{ $t('dettaglioDipendente.sesso') }}</div>
          <div class="testata-value col-16 no-padding">
            <el-select
              v-model="dipendente.sesso"
              :disabled="disabled"
              filterable
              class="custom-select-el"
              popper-class="rightSelect"
            >
              <el-option
                v-for="item in tbl_sesso"
                :key="item.codSesso"
                :label="item.desSesso"
                :value="item.codSesso"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="row row-custom elemento">
          <div class="testata-label col-8">{{ $t('dettaglioDipendente.dataNascita') }}</div>
          <div class="testata-value col-16 no-padding">
            <el-date-picker
              v-model="dipendente.dataNascita"
              :disabled="disabled"
              type="date"
              format="dd/MM/yyyy"
              value-format="yyyyMMdd"
              placeholder
              class="custom-date-picker"
              :picker-options="{
                                firstDayOfWeek: 1
                              }"
            ></el-date-picker>
          </div>
        </div>
        <div class="row row-custom elemento">
          <div class="testata-label col-8">{{ $t('dettaglioDipendente.comuneNascita') }}</div>
          <div class="testata-value col-16 no-padding">
            <el-input v-model="dipendente.comNas" :disabled="disabled" class="custom-input"></el-input>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-sm-20 col-22">
        <div class="row row-custom elemento" v-show="country !== '2'"></div>
        <div class="row row-custom elemento">
          <div class="testata-label col-8">{{ $t('dettaglioDipendente.tipoRapp') }}</div>
          <div class="testata-value col-16 no-padding">
            <el-select
              v-model="dipendente.codTipoRapporto"
              :disabled="disabled"
              filterable
              class="custom-select-el"
              popper-class="rightSelect"
            >
              <el-option
                v-for="item in tbl_tipoRapp"
                :key="item.codTipoRapp"
                :label="item.codTipoRapp + ' - ' + item.desTipoRapp"
                :value="item.codTipoRapp"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="row row-custom elemento">
          <div class="testata-label col-8">{{ $t('dettaglioDipendente.dataAssunzione') }}</div>
          <div class="testata-value col-16 no-padding">
            <el-date-picker
              v-model="dipendente.dataAssunzione"
              :disabled="disabled || !!dipendente.codDip"
              type="date"
              format="dd/MM/yyyy"
              value-format="yyyyMMdd"
              placeholder
              class="custom-date-picker"
              :picker-options="{
                                firstDayOfWeek: 1
                              }"
            ></el-date-picker>
          </div>
        </div>
        <div class="row row-custom elemento">
          <div class="testata-label col-8">{{ $t('dettaglioDipendente.dataCessazione') }}</div>
          <div class="testata-value col-16 no-padding">
            <el-date-picker
              v-model="dipendente.dataCessazione"
              :disabled="disabled"
              type="date"
              format="dd/MM/yyyy"
              value-format="yyyyMMdd"
              placeholder
              class="custom-date-picker"
              :picker-options="{
                                firstDayOfWeek: 1
                              }"
            ></el-date-picker>
          </div>
        </div>
        <div class="row row-custom elemento">
          <div class="testata-label col-8">{{ $t('dettaglioDipendente.mansione') }}</div>
          <div class="testata-value col-16 no-padding">
            <el-select
              v-model="dipendente.codMansione"
              :disabled="disabled"
              filterable
              class="custom-select-el"
              popper-class="rightSelect"
            >
              <el-option
                v-for="item in tbl_mansione"
                :key="item.codMansione"
                :label="item.desMansione"
                :value="item.codMansione"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="row row-custom elemento">
          <div class="testata-label col-8">{{ $t('dettaglioDipendente.cittadinanza') }}</div>
          <div class="testata-value col-16 no-padding">
            <el-select
              v-model="dipendente.codCittadinanza"
              :disabled="disabled"
              filterable
              class="custom-select-el"
              popper-class="rightSelect"
            >
              <el-option
                v-for="item in tbl_cittadinanza"
                :key="item.codCittadinanza"
                :label="item.desCittadinanza"
                :value="item.codCittadinanza"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="row row-custom elemento">
          <div class="testata-label col-8">{{ $t('dettaglioDipendente.residenza') }}</div>
          <div class="testata-value col-16 no-padding">
            <el-select
              v-model="dipendente.codResidenza"
              :disabled="disabled"
              filterable
              class="custom-select-el"
              popper-class="rightSelect"
            >
              <el-option
                v-for="item in tbl_cittadinanza"
                :key="item.codCittadinanza"
                :label="item.desCittadinanza"
                :value="item.codCittadinanza"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>

    <div class="bottoni col-23">
      <el-button v-if="$store.state.DIP_new || !disabled"
        size="small"
        @click="salva()"
        :loading="saveDisabled"
        class="custom-button"
        type="primary"
      >{{ $t('dettaglioDipendente.btn.salva').toUpperCase() }}</el-button>
      <el-button v-if="!$store.state.DIP_new && disabled"
        size="small"
        @click="disabled = false"
        class="custom-button"
      >{{ $t('dettaglioDipendente.btn.modifica').toUpperCase() }}</el-button>
    </div>

    <div>
      <div class="col-24 titoloTab">
        <span>{{$t('dettaglioDipendente.ordine')}}</span>
      </div>

      <!-- Tabella Raggruppamenti Ordini-->
      <el-table
        :data="ordini_Ragg"
        class="col-xs-24 custom-table no-padding"
        v-loading="loading_ordini"
      >
        <el-table-column header-align="center" align="center" width="70">
          <template slot-scope="scope" slot="header">
            <el-popover placement="top" trigger="click" :key="scope.toString()">
              <div>
                <div>
                  <icon :name="getStatoIcon('0')" class="status-saved" scale="1"></icon>
                  <span>{{ $t('dettaglioDipendente.raggStatus.0') }}</span>
                </div>
                <div>
                  <icon :name="getStatoIcon('1')" class="status-send" scale="1"></icon>
                  <span>{{ $t('dettaglioDipendente.raggStatus.1') }}</span>
                </div>
                <div>
                  <icon :name="getStatoIcon('2')" class="status-rejected" scale="1"></icon>
                  <span>{{ $t('dettaglioDipendente.raggStatus.2') }}</span>
                </div>
                <div>
                  <icon :name="getStatoIcon('3')" class="status-rejected" scale="1"></icon>
                  <span>{{ $t('dettaglioDipendente.raggStatus.3') }}</span>
                </div>
              </div>
              <span slot="reference">
                <icon class="pointer" name="riv-help" scale="1"></icon>
              </span>
            </el-popover>
          </template>

          <template slot-scope="scope">
            <div class="data-wrapper">
              <icon name="riv-circle_2" scale="0.7" :style="getClassIcon(scope.row.statoOrdine)"></icon>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="numOrd"
          :label="$t('dettaglioDipendente.ordine')"
          min-width="120"
        >
        
          <template slot-scope="scope">
            <div class="name-wrapper">
              <span>{{scope.row.numOrd}} - {{scope.row.desMag}}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        v-if="(tabDocOrdini_Ragg.nrPages > 1)"
        :current-page="tabDocOrdini_Ragg.currentPage"
        background
        class="custom-pagination"
        layout="prev, pager, next"
        :total="tabDocOrdini_Ragg.nrItems"
        :page-size="tabDocOrdini_Ragg.pag_for"
        @current-change="changePageDocOrdini"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { bus } from "@/components/Bus.js"
import moment from "moment"

export default {
  components: {},
  name: 'DettaglioDipendente',
  i18n: {
    messages: {
      it_IT: {
        dettaglioDipendente: {
          datiAnag: 'Dati Anagrafici',
          dipendente: 'Dipendente',
          cognome: 'Cognome',
          nome: 'Nome',
          cFisc: 'Codice Fiscale',
          sesso: 'Sesso',
          dataNascita: 'Nato il',
          comuneNascita: 'Nato a',
          tipoRapp: 'Tipo Rapporto',
          dataAssunzione: 'Assunto il',
          dataCessazione: 'Cessazione il',
          mansione: 'Mansione',
          cittadinanza: 'Cittadinanza',
          residenza: 'Residenza',
          documenti: 'Documenti',
          generici: 'Generici',
          ordine: 'Ordine',
          tipo: 'Tipo',
          desc: 'Descrizione',
          idDoc: 'Id Documento',
          dtIns: 'Inserito',
          dtDoc: 'Emesso',
          dtSca: 'Scadenza',
          dtApp: 'Verificato il',
          app: 'Verificato da',
          raggStatus: {
            0: 'Nessun Documento Presente',
            1: 'Presenza di almeno un documento da approvare',
            2: 'Tutti i documenti sono in regola',
            3: 'Presenza di almeno un documento non in regola'
          },
          docStatus: {
            1: 'Documento in approvazione',
            2: 'Documenti in regola',
            3: 'Documento Rifiutato',
            4: 'Documento Scaduto'
          },
          btn: {
            salva: 'Salva',
            modifica: 'Modifica',
            convalida: 'Convalida'
          },
          nuovoDoc: 'Upload Nuovo Documento',
          deleteOK: 'Documento cancellato correttamente',
          dipIncompleto: 'Dipendente Incompleto, si prega di compilare le informazioni mancanti.'
        }
      },
      fr_FR: {
        dettaglioDipendente: {
          datiAnag: 'Données personnelles',
          dipendente: 'Employé',
          cognome: 'Nom',
          nome: 'Prénom',
          cFisc: 'N° Sécurité Sociale',
          sesso: 'Sexe',
          dataNascita: 'Né le',
          comuneNascita: 'Né à',
          tipoRapp: 'Type de rapport',
          dataAssunzione: 'Embauché le',
          dataCessazione: 'Cessation le',
          mansione: 'Tâche',
          cittadinanza: 'Citoyenneté',
          residenza: 'Résidence',
          documenti: 'Documents',
          generici: 'Génériques',
          ordine: 'Commande',
          tipo: 'Type',
          desc: 'Description',
          idDoc: 'ID du document',
          dtIns: 'Soumis',
          dtDoc: 'Publié',
          dtSca: 'Date limite',
          dtApp: 'Vérifié le',
          app: 'Vérifié par',
          raggStatus: {
            0: 'Aucun document présent',
            1: "Présence d'au moins un document à approuver",
            2: 'Tous les documents sont en règle',
            3: "Présence d'au moins un document non conforme"
          },
          docStatus: {
            1: "Document en cours d'approbation",
            2: 'Document en ordre',
            3: 'Document rejeté',
            4: 'Document expiré'
          },
          btn: {
            salva: 'Sauver',
            modifica: 'Changement',
            convalida: 'Validation'
          },
          nuovoDoc: 'Téléchargez un nouveau document',
          deleteOK: 'Document supprimé avec succès',
          dipIncompleto: 'Employé incomplet, veuillez remplir les informations manquantes.'
        }
      },
      es_ES: {
        dettaglioDipendente: {
          datiAnag: 'Información personal',
          dipendente: 'Empleado',
          cognome: 'Apellido',
          nome: 'Nombre',
          cFisc: 'Código Fiscal',
          sesso: 'Sexo',
          dataNascita: 'Nacido el',
          comuneNascita: 'Nacido en',
          tipoRapp: 'Tipo de relacion',
          dataAssunzione: 'Contratado el',
          dataCessazione: 'Cesado el',
          mansione: 'Tarea',
          cittadinanza: 'Ciudadanía',
          residenza: 'Residencia',
          documenti: 'Documentos',
          generici: 'Genéricos',
          ordine: 'Orden',
          tipo: 'Tipo',
          desc: 'Descripción',
          idDoc: 'ID del documento',
          dtIns: 'Presentado',
          dtDoc: 'Emitido',
          dtSca: 'Fecha límite',
          dtApp: 'Cambiado el',
          app: 'Cambiado en',
          raggStatus: {
            0: 'No hay documentos presentes',
            1: 'Presencia de al menos un documento para ser aprobado',
            2: 'Todos los documentos están en orden',
            3: 'Presencia de al menos un documento no en orden'
          },
          docStatus: {
            1: 'Documento bajo aprobación',
            2: 'Documentos en orden',
            3: 'Documento rechazado',
            4: 'Documento caducado'
          },
          btn: {
            salva: 'Guardar',
            modifica: 'Cambio',
            convalida: 'Validación'
          },
          nuovoDoc: 'Subir nuevo documento',
          deleteOK: 'Documento eliminado con éxito',
          dipIncompleto: 'Empleado incompleto, complete la información que falta.'
        }
      },
      de_DE: {
        dettaglioDipendente: {
          datiAnag: 'Persönliche Daten',
          dipendente: 'Mitarbeiter',
          cognome: 'Nachname',
          nome: 'Vorname',
          cFisc: 'Abgabenordnung',
          sesso: 'Sex',
          dataNascita: 'Geboren am',
          comuneNascita: 'Geboren in',
          tipoRapp: 'Arbeitsbeziehungstyp',
          dataAssunzione: 'Angestellt am',
          dataCessazione: 'Aufgehört am',
          mansione: 'Aufgabe',
          cittadinanza: 'Staatsbürgerschaft',
          residenza: 'Residenz',
          documenti: 'Unterlagen',
          generici: 'Generika',
          ordine: 'Auftrag',
          tipo: 'Art',
          desc: 'Beschreibung',
          idDoc: 'Dokument Identifikation',
          dtIns: 'Eingereicht',
          dtDoc: 'Ausgegeben',
          dtSca: 'Frist',
          dtApp: 'Geändert am',
          app: 'Geprüft von',
          raggStatus: {
            0: 'Keine Dokumente vorhanden',
            1: 'Vorhandensein mindestens eines zu genehmigenden Dokuments',
            2: 'Alle Dokumente sind in Ordnung',
            3: 'Vorhandensein mindestens eines Dokuments nicht in Ordnung'
          },
          docStatus: {
            1: 'Dokument in Genehmigung',
            2: 'Dokumente in Ordnung',
            3: 'Abgelehntes Dokument',
            4: 'Abgelaufenes Dokument'
          },
          btn: {
            salva: 'Speichern',
            modifica: 'Korrektur',
            convalida: 'Validierung'
          },
          nuovoDoc: 'Neues Dokument hochladen',
          deleteOK: 'Dokument erfolgreich gelöscht',
          dipIncompleto: 'Unvollständiger Mitarbeiter, bitte ergänzen Sie die fehlenden Informationen.'
        }
      },
      en_GB: {
        dettaglioDipendente: {
          datiAnag: 'Personal data',
          dipendente: 'Employee',
          cognome: 'Surname',
          nome: 'Name',
          cFisc: 'Fiscal Code',
          sesso: 'Sex',
          dataNascita: 'Born on',
          comuneNascita: 'Born in',
          tipoRapp: 'Relationship type',
          dataAssunzione: 'Hired on',
          dataCessazione: 'Ceased on',
          mansione: 'Task',
          cittadinanza: 'Citizenship',
          residenza: 'Residence',
          documenti: 'Documents',
          generici: 'Generics',
          ordine: 'Order',
          tipo: 'Type',
          desc: 'Description',
          idDoc: 'Document ID',
          dtIns: 'Submitted',
          dtDoc: 'Issued',
          dtSca: 'Deadline',
          dtApp: 'Verified on',
          app: 'Verified by',
          raggStatus: {
            0: 'No Documents Present',
            1: 'Presence of at least one document to be approved',
            2: 'All documents are in order',
            3: 'Presence of at least one document not in order'
          },
          docStatus: {
            1: 'Document under approval',
            2: 'Documents in order',
            3: 'Rejected document',
            4: 'Expired Document'
          },
          btn: {
            salva: 'Save',
            modifica: 'Change',
            convalida: 'Validation'
          },
          nuovoDoc: 'Upload New Document',
          deleteOK: 'Document successfully deletede',
          dipIncompleto: 'Incomplete employee, please fill in the missing information.'
        }
      }
    }
  },
  props: {
    prefixApp: {
      type: String
    }
  },
  data() {
    return {
      moment: moment,
      codLang: sessionStorage.getItem('codLang'),
      codForn: '',
      country: '',
      dipendente: {},
      tbl_sesso: [],
      tbl_mansione: [],
      tbl_cittadinanza: [],
      tbl_tipoRapp: [],
      disabled: false,
      codDip: '',
      fornitore: '',
      desFornitore: '',
      saveDisabled: false,
      loading: false,
      loading_dip: false,
      loading_ordini: false,
      ordini_Ragg: [],
      tabDocOrdini_Ragg: {
        currentPage: 1,
        pag_for: 5,
        nrPages: 0,
        nrItems: 0,
        counterWarning: 0
      },
      vistaGenerici: 'raggruppamenti',
      vistaOrdini: 'raggruppamenti',
      docRaggruppamento:  {},
      editMode: false
    }
  },
  mounted: function() {
    bus.$on('changeLanguage', () => {
      this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
    })
  },
  activated: function() {
    this.init()
  },
  deactivated: function() {
    this.resetDati()
  },
  methods: {
    link: function(route) {
      this.resetDati()
      this.$router.push({ name: route })
    },
    resetDati: function() {
      this.$set(this, 'codForn', {})
      this.$set(this, 'country', {})
      this.$set(this, 'dipendente', {})
      this.$set(this, 'tbl_sesso', [])
      this.$set(this, 'tbl_mansione', [])
      this.$set(this, 'tbl_cittadinanza', [])
      this.$set(this, 'tbl_tipoRapp', [])
      this.$set(this, 'disabled', false)
      this.$set(this, 'codDip', '')
      this.$set(this, 'fornitore', '')
      this.$set(this, 'desFornitore', '')
      this.$set(this, 'saveDisabled', false)
      this.$set(this, 'loading', false)
      this.$set(this, 'loading_dip', false)
      this.$set(this, 'loading_ordini', false)
      this.$set(this, 'ordini_Ragg', [])
      this.$set(this, 'tabDocOrdini_Ragg', {
        currentPage: 1,
        pag_for: 5,
        nrPages: 0,
        nrItems: 0,
        counterWarning: 0
      })
      this.$set(this, 'vistaOrdini', 'raggruppamenti')
      this.$set(this, 'docRaggruppamento',  {})
    },
    init: function() {
      this.$set(this, 'country', this.$store.state.DIP_Ricerca.country)
      this.getTipoRapp()
      this.getCittadinanza()
      this.getMansioni()
      this.getSesso()
      this.$set(this, 'codForn', this.$store.state.DIP_Ricerca.codForn)
      //this.$set(this, 'dipendente', this.$store.state.DIP_Dipendente)
      if (this.$store.state.DIP_new) {
        // Sto creando un nuovo Dipendente
        this.$set(this, 'dipendente', {})
        this.$set(this.dipendente, 'fornitore', this.$store.state.DIP_Ricerca.fornitore)
        this.$set(this, 'fornitore', this.$store.state.DIP_Ricerca.fornitore)
        this.$set(this, 'desFornitore', this.$store.state.DIP_Ricerca.desFornitore)
      } else {
        this.$set(this, 'codDip', this.$store.state.DIP_Dipendente.codDip)
        this.$set(this, 'fornitore', this.$store.state.DIP_Dipendente.codForn)
        this.$set(this, 'desFornitore', this.$store.state.DIP_Dipendente.desForn)
        this.$set(this, 'disabled', true)
        this.loadDipendente()
      }
    },
    getTipoRapp: function() {
      this.$http.get('anagraficadipendenti/tiporapp', {
        params: {
          codLang: this.codLang,
          country: this.country
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'tbl_tipoRapp', response.body.data)
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    getCittadinanza: function() {
      this.$http.get('anagraficadipendenti/cittadinanza', {
        params: {
          codLang: this.codLang,
          country: this.country,
          filtro: ''
          }
        })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'tbl_cittadinanza', response.body.data)
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    getMansioni: function() {
      this.$http.get('anagraficadipendenti/mansioni', {
        params: {
          codLang: this.codLang,
          country: this.country
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'tbl_mansione', response.body.data)
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    getSesso: function() {
      this.$http.get('anagraficadipendenti/sesso', {
        params: {
          codLang: this.codLang,
          country: this.country
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'tbl_sesso', response.body.data)
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    validaCFisc: function(cfisc) {
      this.$http.get('anagraficadipendenti/cfiscinfo', {
        params: {
          codLang: this.codLang,
          country: this.country,
          codFisc: cfisc === undefined ? '' : cfisc
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this.dipendente, 'sesso', response.body.data[0].Sesso)
            this.$set(
              this.dipendente,
              'dataNascita',
              response.body.data[0].dataNascita
            )
            this.$set(
              this.dipendente,
              'comNas',
              response.body.data[0].luogoNascita
            )
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    loadDipendente: function() {
      this.$set(this, 'loading_dip', true)
      this.$http.get('anagraficadipendenti/dipendente', {
        params: {
          codLang: this.codLang,
          country: this.country,
          fornitore: this.fornitore,
          codDip: this.codDip,
          codForn: this.codForn
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'dipendente', response.body.data[0])
            if (this.$store.state.DIP_new) {
              let dip = {
                codDip: this.dipendente.codDip,
                cognome: this.dipendente.cognome,
                nome: this.dipendente.nome,
                dataNascita: this.dipendente.dataNascita,
                luogoNascita: this.dipendente.comNas,
                sesso: this.dipendente.sesso,
                dataAssunzione: this.dipendente.dataAssunzione,
                dataCessazione: this.dipendente.dataCessazione,
                codMansione: this.dipendente.codMansione,
                desMansione: '',
                codTipoRap: this.dipendente.codTipoRapporto,
                desTipoRap: '',
                codForn: this.dipendente.fornitore,
                desForn: this.$store.state.DIP_Ricerca.desFornitore
              }
              this.$store.commit('set', {key: 'DIP_new', value: false})
              this.$store.commit('set', {key: 'DIP_Dipendente', value: dip})
            }
            this.$set(this, 'loading_dip', false)
            this.getDocOrdini()
            if (this.dipendente.completo === 'N')
              this.$message({
                showClose: true,
                message: this.$t('dettaglioDipendente.dipIncompleto'),
                type: 'warning',
                duration: process.env.duration
              })
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
            this.$set(this, 'loading_dip', false)
          }
        })
    },
    changePageDocOrdini: function(page) {
      this.$set(this.tabDocOrdini_Ragg, 'currentPage', page)
      this.getDocOrdini()
    },
    getDocOrdini: function() {
      this.$set(this, 'loading_ordini', true)
      this.$http.get('anagraficadipendenti/ordini', {
        params: {
          codLang: this.codLang,
          country: this.country,
          pag_action: this.tabDocOrdini_Ragg.currentPage > 1 ? 'NEXT' : 'BEGIN',
          pag_from: (this.tabDocOrdini_Ragg.currentPage - 1) * this.tabDocOrdini_Ragg.pag_for + 1,
          pag_for: this.tabDocOrdini_Ragg.pag_for,
          codForn: this.codForn,
          fornitore: this.fornitore,
          codDip: this.codDip
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'ordini_Ragg', response.body.data)

            if (this.tabDocOrdini_Ragg.currentPage === 1) {
              this.$set(this.tabDocOrdini_Ragg, 'counterWarning', parseInt(response.body.attrib.nOrdAlert))
              this.$set(this.tabDocOrdini_Ragg, 'nrItems', parseInt(response.body.attrib.size))
              let resto = parseInt(response.body.attrib.size) % this.tabDocOrdini_Ragg.pag_for
              let aggiunta = resto > 0 ? 1 : 0
              let nrPages = Math.floor(parseInt(response.body.attrib.size) / this.tabDocOrdini_Ragg.pag_for) + aggiunta
              this.$set(this.tabDocOrdini_Ragg, 'nrPages', nrPages)
            }
          } else {
            this.$set(this, 'ordini_Ragg', [])
            this.$set(this.tabDocOrdini_Ragg, 'currentPage', 1)
            this.$set(this.tabDocOrdini_Ragg, 'nrPages', 0)
            this.$set(this.tabDocOrdini_Ragg, 'nrItems', 0)
            this.$set(this.tabDocOrdini_Ragg, 'counterWarning', 0)
            if (response.body.msg[0].msgId !== '1001') {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          }
          this.$set(this, 'loading_ordini', false)
        })
    },
    getStatoIcon: function(stato) {
      switch (stato) {
        case '0':
          return 'riv-docNew_2'
        case '1':
          return 'riv-docWaiting_2'
        case '2':
          return 'riv-docAccepted_2'
        case '3':
          return 'riv-docRefused_2'
        case '4':
          return 'riv-docRefused_3'
        default:
          return ''
      }
    },
    getClassIcon: function(stato) {
      switch (stato) {
        case '0':
          return 'color: #ccc'
        case '1':
          return 'color: #ded126'
        case '2':
          return 'color: #41ab35'
        case '3':
          return 'color: #e64546'
        case '4':
          return 'color: #0aa6d3'
        default:
          return ''
      }
    },
    salva: function() {
      this.$set(this, 'saveDisabled', true)

      let data = {
        op: this.$store.state.DIP_new ? '*ADD' : '*UPD',
        fornitore: this.dipendente.fornitore, //arriva dalla select
        codDip: this.$store.state.DIP_new ? '' : this.dipendente.codDip,
        codFisc: this.dipendente.codFisc,
        cognome: this.dipendente.cognome.toUpperCase(),
        nome: this.dipendente.nome.toUpperCase(),
        dataNascita: this.dipendente.dataNascita,
        sesso: this.dipendente.sesso,
        comNas: this.dipendente.comNas,
        codCittadinanza: this.dipendente.codCittadinanza,
        codResidenza: this.dipendente.codResidenza,
        dataAssunzione: this.dipendente.dataAssunzione,
        dataCessazione: this.dipendente.dataCessazione,
        codMansione: this.dipendente.codMansione,
        codTipoRapporto: this.dipendente.codTipoRapporto
      }

      this.$http.post('anagraficadipendenti/dipendente', data, {
        params: {
          codLang: this.codLang,
          country: this.country,
          codForn: this.codForn
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            // this.$router.push({name: 'DIPDipendente'})
            // if (this.$store.state.DIP_new) {
              this.$set(this, 'codDip', response.body.attrib.codDip)
              this.$set(this, 'fornitore', response.body.attrib.fornitore)
              this.$set(this, 'disabled', true)
              this.loadDipendente()
            // }
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.$set(this, 'saveDisabled', false)
          this.$set(this, 'showContinua', false)
        })
    },
    openTipologiaDoc: function(row) {
      this.$set(this, 'vistaGenerici', 'docsGenerici')
      this.getDocGenericiDocs(row)
    },
    getDocumento: function (doc) {
      this.$http.get('portale/tokendoc')
        .then(response => {
          if (response.body.wsToken) {
            let url = (process.env.baseUrlSpringAccessoStabilimenti + 'print/doc?idCli=RIV&idApp=FORDOCDIT' + '&keyDoc=' +  doc.idDoc + '&quality='+ process.env.qualityCM + '&token=' + response.body.wsToken)
            /*let url = (process.env.baseUrl + process.env.jaxrsFornAccStab + 'print/' + this.codLang + '/' +
                this.country + '/docdipendente/' + doc.idDoc + '?quality='+ process.env.qualityCM +
                '&token=' + response.body.wsToken)*/
            let win = window.open(url, '_blank')
            win.focus()
          } else {
            this.$message({
              showClose: true,
              message: 'Error creating token',
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    openDocumento: function(row, event, column) {
      let documento = {
        route: 'DIPDipendente'
      }
      this.$store.commit('set', { key: 'GA_Documento', value: documento })
      this.$router.push({ name: 'DIPDocumento', params: { id: row.idDoc } })
    },
    uploadDocumento: function() {
      let codValidita = '900'
      let documento = {
        codDip: this.dipendente.codDip,
        desDip: this.dipendente.cognome + ' ' + this.dipendente.nome,
        codForn: this.codForn,
        codTipo: this.docRaggruppamento.codTipo,
        desTipo: this.docRaggruppamento.desTipo,
        codValidita: codValidita,
        annoOrd: this.docRaggruppamento.annoOrd,
        numOrd: this.docRaggruppamento.numOrd,
        codSoc: this.docRaggruppamento.codSoc,
        desSoc: this.docRaggruppamento.desSoc,
        codMag: this.docRaggruppamento.codMag,
        desMag: this.docRaggruppamento.desMag,
        route: 'DIPDipendente'
      }
      this.$store.commit('set', { key: 'GA_Documento', value: documento })
      this.$router.push({ name: 'DIPDocumento' })
    }
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import "../../../../assets/less/general.less";

@media only screen and (max-width: 875px) and (min-width: 776px) {
  .modal-documenti {
    .el-dialog__body {
      .upload {
        .upload-demo {
          width: 550px;
          .el-upload-list {
            width: 400px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 775px) {
  .modal-documenti {
    .el-dialog__body {
      .upload {
        .upload-demo {
          width: 400px;
          .el-upload-list {
            width: 250px;
          }
        }
      }
    }
  }
}
.dettaglio-dipendente {
  height: auto;
  .header-tab {
    margin-top: 12px;
    height: 30px;
    text-align: center;
    .return {
      padding-left: 15px;
      .fa-icon {
        margin-top: 5px;
        line-height: 30px;
        float: left;
      }
      span {
        float: left;
        text-transform: uppercase;
        line-height: 30px;
        height: 30px;
        .set-font(@color: @oroRiva; @size: 16px; @family: "os-semibolditalic");
      }
    }
    .fornitore {
      .set-font(@color: @greenRiva; @size: 16px; @family: "os-semibolditalic");
      text-align: right;
    }
    .my-label {
      padding-left: 20px;
      line-height: 55px;
      height: 45px;
      .set-font(@color: @oroRiva; @size: 22px; @family: "os-semibolditalic");
    }
    .sotto-label {
      .set-font(@size: 15px; @family: "os-lightitalic");
      height: 25px;
    }
  }
  .testata {
    margin-top: 20px;
    .elemento-grande {
      margin-bottom: 0px !important;
    }
    .elemento {
      height: 21px;
      margin-bottom: 5px;
      .testata-label {
        .set-font(@size: 11px; @color: @greenRiva; @family: "os-semibold");
        text-align: right;
        line-height: 20px;
        text-transform: uppercase;
        letter-spacing: 1px;
      }
      .testata-doppia {
        .my-label {
          margin-bottom: 5px;
          line-height: 20px;
        }
      }
      .testata-value {
        .custom-input {
          input[type=text] {
            padding-left: 5px;
          }
        }
        .custom-select-el {
          input[type=text] {
            padding-left: 5px;
          }
        }
        .el-input__inner {
          //padding-left: 5px;
          font-size: 12px;
          letter-spacing: 1px;
          border: 1px solid #dcdfe6 !important
        }
        .el-input-group--append {
          .el-input-group__append {
            border-radius: 0;
            background-color: transparent;
            .set-font(@size: 12px; @color: @oroRiva);
            .el-button {
              padding-top: 4px;
              padding-bottom: 4px;
              padding-left: 6px;
              padding-right: 6px;
            }
          }
          .el-input__inner {
            border-right: 1px solid white;
            &:focus {
              border: 1px solid @greenRiva;
            }
          }
        }
      }
    }
  }
  .separatore {
    border-top: 1px solid #e7e7e7;
    margin-top: 15px;
    margin-bottom: 20px;
  }

  .bottoni {
    margin-top: 30px;
    margin-bottom: 10px;
    text-align: right;
  }

  .return-tab {
    flex: auto;
    padding-bottom: 15px;
    .fa-icon {
      margin-top: 5px;
      line-height: 30px;
      float: left;
    }
    span {
      float: left;
      text-transform: uppercase;
      line-height: 30px;
      height: 30px;
      padding-left: 15px;
      .set-font(@color: @greenRiva; @size: 16px; @family: "os-semibolditalic");
    }
    .capitalize {
      text-transform: capitalize;
      padding-left: 5px;
    }
  }
  .add {
    margin-top: 4px;
    line-height: 30px;
    color: #bb515c;
  }
  .titoloTab {
    margin-bottom: 15px;
    span {
      .set-font(@size: 16px; @color: @rossoRiva; @family: "os-semibolditalic");
      text-transform: capitalize;
      line-height: 30px;
      font-weight: normal;
      //border-bottom: 1px solid #bb515c;
      display: block;
      text-align: center;
    }
  }
  .custom-tabs {
    min-height: 310px;
    &.el-tabs {
      .el-tabs__header {
        .counter-nuovi {
          .el-badge {
            .el-badge__content {
              height: 18px;
              width: 18px;
              top: 9px;
              right: -3px;
              padding: 0;
              line-height: 16px;
              .set-font(@color: @white, @size: 10px);
              letter-spacing: 0;
              background-color: @oroRiva;
            }
          }
        }
        .el-tabs__item {
          width: 250px;
          font-size: 14px;
          text-transform: capitalize;
        }
      }
      .el-table__body-wrapper {
        .tipoDoc {
          background-color: #eff6f6;
          text-align: left;
          .cell {
            .set-font(@color: @greenRiva, @family: 'os-semibolditalic', @size: 13px) !important;
          }
        }
      }
    }
  }

  .custom-table {
    .el-table__header {
      thead {
        th {
          .cell {
            font-size: 13px;
          }
        }
      }
    }
    .el-table__body-wrapper {
      min-height: 170px;
      .cell {
        .scaduto {
          .set-font(@color: @rossoRiva; @family: "os-semibold");
        }
      }
    }
    .action {
      .fa-icon {
        color: @rossoRiva;
      }
    }
    td {
      padding-top: 5px;
      padding-bottom: 5px;
      &.el-table__expanded-cell {
        padding: 0px 0px 0px 70px !important;
        .el-table {
          .el-table__header-wrapper {
            border-bottom: 1px solid #ccc;
            .el-table__header {
              th {
                .cell {
                  .set-font(@family: "os-lightitalic", @size: 12px);
                }
              }
            }
          }
          .el-table__body-wrapper {
            min-height: auto;
            .el-table__body {
              .lastRow {
                td {
                  border-bottom: none;
                }
              }
              td {
                padding: 3px 0;
                .cell {
                  .set-font(
                    @family: "os-regular",
                    @size: 11px,
                    @color: @textTable
                  );
                  line-height: 20px !important;
                }
              }
            }
          }
        }
      }
      &.el-table__expanded-cell:hover {
        background-color: @white;
      }
    }
  }
}
/*.el-select-dropdown {
    &.rightSelect {
      text-align: right;
    }
  }*/
</style>



// WEBPACK FOOTER //
// src/components/AccessoStabilimenti/GestioneAppalti/AnagraficaDipendenti/DettaglioDipendente.vue